import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { createAdminNotification } from "../../../utils/notificationService";
import { orderTerms } from "../../../data";
import { getDocByKeyValue, saveData, uploadImage } from "../../../firebase/utility";
import { getCustomerOrders } from "../../../api/pagination";
const useCustomerDetails = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const { user } = useSelector((state) => state.auth);
  const [customerInfo, setCustomerInfo] = useState(state ?? {});
  console.log('customerInfo', customerInfo)
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [saleOrdersByCustomers, setSaleOrdersByCustomers] = useState([]);
  const [note, setNote] = useState("");
  const [taxExempt, setTaxExempt] = useState(false)
  const [taxExemptStates, setTaxExemptStates] = useState([])
  const [soLoading, setSoLoading] = useState(false)
  const [taxCerfificate, setTaxCertificate] = useState(customerInfo?.taxCertificate ?? null)
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [billingData, setBillingData] = useState({
    company: state?.billing?.[0]?.company ?? "",
    first_name: state?.billing?.[0]?.first_name ?? "",
    last_name: state?.billing?.[0]?.last_name ?? "",
    EIN: state?.billing?.[0]?.EIN ?? state?.billing?.[0]?.ein ?? state?.EIN ?? state?.ein ?? "",
    address_1: state?.billing?.[0]?.address_1 ?? "",
    address_2: state?.billing?.[0]?.address_2 ?? "",
    country: state?.billing?.[0]?.country ?? "",
    city: state?.billing?.[0]?.city ?? "",
    state: state?.billing?.[0]?.state ?? "",
    phone: state?.billing?.[0]?.phone ?? "",
    postcode: state?.billing?.[0]?.postcode ?? "",
    email: state?.billing?.[0]?.email ?? "",
    creditLimit: state?.billing?.[0]?.creditLimit ?? false,
    terms: state?.billing?.[0]?.terms ?? "",
  });
  const addCustomerNotes = () => {
    if (note !== "") {
      const obj = {
        createdAt: Date.now(),
        createdBy: user,
        message: note,
      };
      setCustomerInfo((prev) => ({
        ...prev,
        notes: prev?.notes?.length > 0 ? [...prev.notes, obj] : [obj],
      }));
      setNote("");
      toast.success("Note added, please press update to save");
    }
  };
  const handleUpdate = async () => {
    setLoader(true);
    const updatedBillingArray = [...(customerInfo?.billing || [])];
    if (updatedBillingArray.length > 0) {
      updatedBillingArray[0] = billingData;
    } else {
      updatedBillingArray[0] = billingData;
    }
    const updatedData = {
      billing: updatedBillingArray,
      _id: customerInfo?._id,
      id: customerInfo?.id,
      first_name: billingData?.first_name,
      last_name: billingData?.last_name,
      EIN: billingData?.EIN ?? billingData?.ein ?? "",
      notes: customerInfo?.notes ?? [],
      taxExemptStates: taxExemptStates ?? [],
      createdAt: customerInfo?.createdAt ?? Date.parse(new Date),
      updatedAt: Date.parse(new Date),
    };


    if (taxCerfificate && typeof taxCerfificate === "object") {
      try {
        let url = await uploadImage(taxCerfificate, "taxCertificates");
        if (url) {
          updatedData.taxCertificate = url;

        } else {
          toast.error("Error uploading tax certificate");
        }
      }
      catch (err) {
        console.error("Error uploading tax certificate:", err);
      }

    } else {
      updatedData.taxCertificate = taxCerfificate;
    }
    saveData("Customers", customerInfo?._id, updatedData).then((res) => {
      if (res) {
        toast.success("Customer Updated Successfully!");
        createAdminNotification({
          title: "Customer Updated",
          message: `Customer ${customerInfo?.billing?.[0]?.first_name || ""} ${customerInfo?.billing?.[0]?.last_name || ""} was updated by ${user?.username || "Admin"}`,
          category: "customer",
          entityId: customerInfo?._id,
          targetUrl: `/admin/customer-details/${customerInfo?._id}`,
          actor: user,
        }).catch(console.error);
        setLoader(false);
        setCustomerInfo((prev) => ({
          ...prev,
          ...updatedData,
        }));
      }
    });
  };
  const handleApprove = () => {
    const updatedData = {
      approved: true,
      updatedAt: Date.parse(new Date),
    }
    saveData("Customers", customerInfo?._id, updatedData).then((res) => {
      if (res) {
        toast.success(
          `${customerInfo?.first_name} ${customerInfo?.last_name} has been approved successfully`
        );
        setCustomerInfo((prev) => ({
          ...prev,
          approved: true,
        }));
      }
    });
  };
  const handleReject = () => {
    const updatedData = {
      approved: false,
      updatedAt: Date.parse(new Date),
    }
    saveData("Customers", customerInfo?._id, updatedData).then(
      (res) => {
        if (res) {
          toast.success(
            `${customerInfo?.first_name} ${customerInfo?.last_name} has been rejected successfully`
          );
          setCustomerInfo((prev) => ({
            ...prev,
            approved: false,
          }));
        }
      }
    );
  };
  useEffect(() => {
    if (customerInfo?.quickbooks_id) {
      setSoLoading(true)
      getCustomerOrders(customerInfo?.quickbooks_id, page, pageSize, (res) => {
        if (res.status === 200) {
          setSaleOrdersByCustomers(res?.data?.data || []);
          setTotalPages(res?.data?.pagination?.totalItems || 0);
          if (res?.data?.pagination?.pageSize) {
            setPageSize(res.data.pagination.pageSize);
          }
          setSoLoading(false)
        } else {
          setSoLoading(false)
          setSaleOrdersByCustomers([]);
          setTotalPages(0);
        }
      })
    }
  }, [customerInfo?.quickbooks_id, page, pageSize]);
  useEffect(() => {
    if (id) {
      getDocByKeyValue("Customers", "_id", id).then((res) => {
        if (res && res[0]) {
          const data = res[0];

          setLoading(false);
          setCustomerInfo(data);
          setTaxExemptStates(data?.taxExemptStates ?? []);
          if (data?.taxExemptStates?.length > 0) { setTaxExempt(true); }
          setBillingData({
            company: data?.billing?.[0]?.company ?? "",
            first_name: data?.billing?.[0]?.first_name ?? "",
            last_name: data?.billing?.[0]?.last_name ?? "",
            EIN: data?.billing?.[0]?.EIN ?? data?.billing?.[0]?.ein ?? data?.EIN ?? data?.ein ?? "",
            address_1: data?.billing?.[0]?.address_1 ?? "",
            address_2: data?.billing?.[0]?.address_2 ?? "",
            country: data?.billing?.[0]?.country ?? "",
            city: data?.billing?.[0]?.city ?? "",
            state: data?.billing?.[0]?.state ?? "",
            phone: data?.billing?.[0]?.phone ?? "",
            postcode: data?.billing?.[0]?.postcode ?? "",
            email: data?.billing?.[0]?.email ?? "",
            creditLimit: data?.billing?.[0]?.creditLimit ?? false,
            terms:
              orderTerms?.find((i) => i?.value === data?.billing?.[0]?.terms)
                ?.value ?? "",
          });
        }
      });
    }
  }, [id]);
  return {
    state,
    customerInfo,
    setCustomerInfo,
    note,
    setNote,
    billingData,
    setBillingData,
    addCustomerNotes,
    handleUpdate,
    saleOrdersByCustomers,
    loading,
    loader,
    handleApprove,
    handleReject,
    taxExempt,
    setTaxExempt,
    taxExemptStates,
    setTaxExemptStates,
    soLoading,
    taxCerfificate, setTaxCertificate,
    page, setPage,
    pageSize, setPageSize,
    totalPages, setTotalPages
  };
};
export default useCustomerDetails;
